import React, {useEffect, useRef, useState} from 'react';
import { Row, Col, Card, Button, Form } from 'react-bootstrap';
import {toast} from "react-toastify";
import {add, listUnusedPlayers, listUnusedStaff} from '../../../lib/api/clubStaff';
import Select from "react-select";

export function Add({ initialData, initStaffType, onClose, onSave }) {
  console.clear();
  console.log('initialData',initialData)
  const [club, setClub] = useState(initialData);
  const [staffType, setStaffType] = useState(initStaffType);
  const [staff, setStaff] = useState([]);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    (async () => {
      const resStaff = await listUnusedStaff({clubs_staff_type_id: staffType.clubs_staff_type_id},club.club_guid);
      console.clear();
      console.log('resStaff',resStaff)

      const options = resStaff.map(({ entities_id, full_name = '' }) => ({
        value: entities_id,
        label: full_name
      }));
      console.log('options',options)
      setStaff(options);
    })();
  }, [club,staffType]);

  const handleSubmit = async event => {
    event.preventDefault();
    try {
      await add({clubs_staff_type_id: staffType.clubs_staff_type_id, entities_id: selected.value}, club.club_guid);
      onSave();
      onClose();
    }catch (err) {
      toast.error(
          <span>
            <p>Došlo je do greške.</p>
            <p>{err.body?.message || err.message}</p>
          </span>
      );
    }
  };

  return (
      <Card>
        <Card.Body className="bg-body-tertiary">
          <Form
              method="POST"
              encType="multipart/form-data"
              noValidate
              onSubmit={handleSubmit}
          >
            <Row className="mb-3">
              <Form.Group as={Col} md="12" controlId="contact_type_id">
                <Form.Label>Izaberi osoblje</Form.Label>
                <Select
                    closeMenuOnSelect={true}
                    options={staff}
                    placeholder="Select..."
                    isMulti={false}
                    classNamePrefix="react-select"
                    value={selected}
                    onChange={opt => setSelected(opt)}
                />
              </Form.Group>
            </Row>



            <Button type="submit">Sačuvaj</Button>
          </Form>
        </Card.Body>
      </Card>
  );
}
